/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { tunneledMcpGetServerMetrics } from "../funcs/tunneledMcpGetServerMetrics.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { TunnelMetrics } from "../models/components/tunnelmetrics.js";
import {
  GetTunneledMcpServerMetricsRequest,
  GetTunneledMcpServerMetricsSecurity,
  Window,
} from "../models/operations/gettunneledmcpservermetrics.js";
import { unwrapAsync } from "../types/fp.js";
export type GetTunneledMcpServerMetricsQueryData = TunnelMetrics;

export function prefetchGetTunneledMcpServerMetrics(
  queryClient: QueryClient,
  client$: GramCore,
  request: GetTunneledMcpServerMetricsRequest,
  security?: GetTunneledMcpServerMetricsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildGetTunneledMcpServerMetricsQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildGetTunneledMcpServerMetricsQuery(
  client$: GramCore,
  request: GetTunneledMcpServerMetricsRequest,
  security?: GetTunneledMcpServerMetricsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<GetTunneledMcpServerMetricsQueryData>;
} {
  return {
    queryKey: queryKeyGetTunneledMcpServerMetrics({
      id: request.id,
      window: request.window,
      gramSession: request.gramSession,
      gramKey: request.gramKey,
      gramProject: request.gramProject,
    }),
    queryFn: async function getTunneledMcpServerMetricsQueryFn(
      ctx,
    ): Promise<GetTunneledMcpServerMetricsQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(tunneledMcpGetServerMetrics(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyGetTunneledMcpServerMetrics(
  parameters: {
    id: string;
    window?: Window | undefined;
    gramSession?: string | undefined;
    gramKey?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "tunneledMcp", "getServerMetrics", parameters];
}
